import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';

const LockStatusPopup = ({ isOpen, message, isLocked, lockCode, onClose }) => {
    
    return (
        <Dialog open={isOpen} onClose={onClose} aria-labelledby="lock-status-dialog-title" sx={{
            '& .MuiDialog-paper': {
              borderRadius: '8px',
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
              width: '400px',
              height: '200px',
            },
          }}>
        <DialogTitle id="lock-status-dialog-title" sx={{
          fontSize: '16px',
          fontWeight: 'bold',
          color: '#333',
          padding: '16px 24px',
        }}>{lockCode}</DialogTitle>
        <DialogContent sx={{ padding: '0 24px 16px' }}>
          <Typography variant="body1" sx={{
            fontSize: '14px',
            color: '#333',
          }}>{message}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} sx={{
            backgroundColor: '#00695c',
            color: 'white',
            borderRadius: '4px',
            padding: '6px 16px',
            fontSize: '14px',
            fontWeight: 'normal',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#004d40',
            },
          }}>
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  
  export default LockStatusPopup;